import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/**
 * same as text input, but accepts additional props:
 * {status (one of 'ok', 'fail', 'pending'), msg: (string), inputId: number (required)}
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import DatePicker from "../DatePicker";
import TextInput from '.';
import { omit } from "../Form/utils";
import styles from "./SmartInput.pcss";
var cx = classNames.bind(styles);
var SmartInput = /*#__PURE__*/function (_Component) {
  _inherits(SmartInput, _Component);
  var _super = _createSuper(SmartInput);
  function SmartInput() {
    var _this;
    _classCallCheck(this, SmartInput);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "statusClasses", function (prefix) {
      var _ref;
      return _ref = {}, _defineProperty(_ref, prefix, true), _defineProperty(_ref, "".concat(prefix, "Ok"), _this.props.status === 'ok'), _defineProperty(_ref, "".concat(prefix, "Fail"), _this.props.status === 'fail'), _defineProperty(_ref, "".concat(prefix, "Pending"), _this.props.status === 'pending'), _ref;
    });
    _defineProperty(_assertThisInitialized(_this), "getInputStatus", function () {
      return _this.props.status === 'typo' ? 'fail' : _this.props.status;
    });
    return _this;
  }
  _createClass(SmartInput, [{
    key: "getValue",
    value: function getValue() {
      return this.input.getValue();
    }
  }, {
    key: "renderField",
    value: function renderField() {
      var _this2 = this;
      var _this$props = this.props,
        type = _this$props.type,
        textInputClass = _this$props.textInputClass;
      var domProps = omit(this.props, ['forceError', 'inputId', 'textInputClass']);
      var field;
      if (type === 'date') {
        field = /*#__PURE__*/React.createElement(DatePicker, _extends({}, domProps, {
          ref: function ref(input) {
            _this2.input = input;
          },
          status: this.getInputStatus(),
          "data-t-id": "components-TextInput"
        }));
      } else {
        field = /*#__PURE__*/React.createElement(TextInput, _extends({}, domProps, {
          className: textInputClass,
          ref: function ref(input) {
            _this2.input = input;
          },
          status: this.getInputStatus()
        }));
      }
      return field;
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: cx(this.props.className, this.statusClasses('container'), this.props.forceError && 'forceError')
      }, this.renderField(), /*#__PURE__*/React.createElement("div", {
        className: cx(this.statusClasses('text'))
      }, this.props.msg));
    }
  }]);
  return SmartInput;
}(Component);
export { SmartInput as default };
SmartInput.propTypes = process.env.NODE_ENV !== "production" ? {
  status: PropTypes.string,
  type: PropTypes.string,
  msg: PropTypes.string,
  className: PropTypes.any,
  textInputClass: PropTypes.string,
  forceTouch: PropTypes.bool,
  forceError: PropTypes.bool
} : {};